import type { NavigateFunction } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

export function setNavigateRef(navigate: NavigateFunction): void {
  navigateRef = navigate;
}

export function getNavigateRef(): NavigateFunction | null {
  return navigateRef;
}
